import React from "react";

export const Endometriosis02: React.FC = () => {
  return (
    <div id="endometriosis" className="endo02-section">
      <div className="endo02-container">
        <h2 className="endo02-title">Endometriosis y endometrio</h2>
        
        <div className="endo02-content">
          <div className="endo02-left">
            <p className="endo02-text">
              El tejido que produce la endometriosis es <span className="endo02-highlight-blue">SIMILAR</span> al endometrio pero no es
              igual: tiene múltiples diferencias y actúa de forma distinta en el cuerpo. Lo más interesante
              a destacar es que <span className="endo02-highlight-pink">las lesiones de endometriosis tienen la capacidad de producir su propio
              estrógeno local</span>, lo que hace que su tratamiento sea bastante complejo.
            </p>
            <p className="endo02-text">
              También es muy importante distinguirla de su patología "hermana" como se la conoce habitualmente
              que es la Adenomiosis. En este caso, el tejido endometrial invade la pared uterina llamada Miometrio.
              La endometriosis y la adenomiosis se presentan juntas hasta en un 50-60% de los casos, pero a
              diferencia de la endometriosis, <span className="endo02-bold">la adenomiosis sí tiene cura</span> a través de la extirpación del útero.
            </p>
            
            <div className="moreinfo-image-container">
              <img
                src="img/micro.png"
                className="moreinfo-image"
                alt="Microscope research"
              />
            </div>
          </div>
          
          <div className="endo02-right">
            <p className="endo02-text">
              <span className="endo02-highlight-blue">Tener la definición correcta es crucial ya que afecta directamente nuestro tratamiento y decisiones
              sobre la patología</span>. Desafortunadamente la información sobre la endometriosis suele estar desactualizada,
              incluso en sitios web que deberían ser referentes en el tema.
            </p>
            
            <p className="endo02-quote">
              <em>
                "La doctrina pública de que la endometriosis no es más que una enfermedad de dolor menstrual "normal" provocado por un "endometrio rebelde" influye en gran medida en las deficiencias de la investigación y el tratamiento, al sostener que la afección se limita a la menstruación y puede "curarse" mediante la supresión hormonal o la histerectomía, ninguna de las cuales es cierta."
              </em>{" "}
              <br />
              <strong className="endo02-author">KEN SINERVO</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};